<script lang="ts">
  import TwitterShare from "@shared/svelte/Components/SocialMediaShare/TwitterShare.svelte";
  import FacebookShare from "@shared/svelte/Components/SocialMediaShare/FacebookShare.svelte";
  import InstagramShare from "@shared/svelte/Components/SocialMediaShare/InstagramShare.svelte";
  import WebsiteShare from "@shared/svelte/Components/SocialMediaShare/WebsiteShare.svelte";
  import type { Storefront } from "@shared/types/Storefront";
  export let storefront: Storefront;

</script>

<div class="fizz-space-between fizz-padded-border-top fizz-stack-32" id="storefront_footer">
  <p class="fizz-text-medium"><strong>{storefront.distributor.name}</strong></p>

  <ul class="fizz-flex-row-4">
    {#if storefront.website_link}
      <WebsiteShare url={storefront.website_link} />
    {/if}
    {#if storefront.twitter_link}
      <TwitterShare url={storefront.twitter_link} personalLink={true} />
    {/if}
    {#if storefront.facebook_link}
      <FacebookShare url={storefront.facebook_link} personalLink={true} />
    {/if}
    {#if storefront.instagram_link}
      <InstagramShare url={storefront.instagram_link} />
    {/if}
  </ul>
</div>
